<template>
    <div class="flights-search">
        <div class="relative h-[400px] py-5 w-[400px] lg:w-[400px] flex flex-col justify-center">
            <div class="border rounded-2xl border-black absolute left-0 bottom-0 top-0 w-full h-full flex justify-center items-center bg-container">
                <app-searcher-wrapper>
                    <search-form-aside :city-destination-code="cityDestinationCode" :itineraries="itineraries" :extra-no-promo-percentage="extraNoPromoPercentage"></search-form-aside>
                </app-searcher-wrapper>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import SearcherWrapper from './components/SearcherWrapper.vue';
import SearchFormAside from './components/SearchFormAside/SearchFormAside.vue';
export default {
    props:{
        cityDestinationCode: String,
        itineraries: Array,
        extraNoPromoPercentage: {
            type: Number,
            required: false,
            default: 0
        }
    },
    components: {
        SearchFormAside,
        'app-searcher-wrapper': SearcherWrapper
    }
}
</script>

<style lang="scss">
.bg-container {
    background-color: #001D38;
}
</style>
